// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseInputs_container__j5qR7","slideIn":"BaseInputs_slideIn__1736v","value__container":"BaseInputs_value__container__3cZgS","amount":"BaseInputs_amount__2xZVi"};